import { IVideoPlayerComponent } from "front-end/components/video-box/factories/video-player.component";
import { VideoPlayerComponentBase } from "front-end/components/video-box/factories/video-player.component.base";

export class UmbracoPlayerComponent extends VideoPlayerComponentBase implements IVideoPlayerComponent {
    private _internalPlayer: HTMLVideoElement = null;

    public play(): void {
        void this._internalPlayer.play();
    }

    public pause(): void {
        void this._internalPlayer.pause();
    }

    public loop(state: boolean): void {
        this._internalPlayer.loop = state;
    }

    public mute(): void {
        this._internalPlayer.muted = true;
    }

    public destroy(): void {
        this._internalPlayer.pause();
        this._internalPlayer.currentTime = 0;
    }

    private bindEvents(): void {
        $(this._internalPlayer)
            .on("playing", () => this.setState(true))
            .on("pause", () => this.setState(false));
    }

    public init(internalPlayer: HTMLVideoElement): void {
        this._internalPlayer = internalPlayer;
        this.bindEvents();
    }

    private setState(isPlaying: boolean): void {
        this._isPlaying.next(isPlaying);
    }
}
